import type { WebTheme } from '../types';
import type { TipJarLayout } from './TipJar.types';

const SYSTEM_FONT_STACK =
  'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';

/** What follows a theme font family in Orchid's root styles (`getRootStyles`) and Swarm's `web_themes/_stylesheet`. */
export const WEB_THEME_FONT_STACK = `${SYSTEM_FONT_STACK}, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;

/**
 * Orchid sets these on `:root` from the site's web theme (`web_themes/_stylesheet`). Anywhere else, set them on a
 * wrapper in the same format: colors as CSS colors, fonts as a family followed by its fallbacks, and the radius as a
 * length.
 */
export const TIP_JAR_THEME_VARIABLES = {
  '--wt-primary-color': { webThemeKey: 'primary_color', fallback: '#030712' },
  '--wt-text-on-primary-color': { webThemeKey: 'text_on_primary_color', fallback: '#FFFFFF' },
  '--wt-background-color': { webThemeKey: 'background_color', fallback: '#FFFFFF' },
  '--wt-text-on-background-color': { webThemeKey: 'text_on_background_color', fallback: '#030712' },
  '--wt-subscribe-background-color': { webThemeKey: 'subscribe_background_color', fallback: '#FFFFFF' },
  '--wt-text-on-subscribe-background-color': { webThemeKey: 'text_on_subscribe_background_color', fallback: '#030712' },
  '--wt-header-font': { webThemeKey: 'header_font', fallback: SYSTEM_FONT_STACK },
  '--wt-body-font': { webThemeKey: 'body_font', fallback: SYSTEM_FONT_STACK },
  '--wt-button-font': { webThemeKey: 'button_font', fallback: SYSTEM_FONT_STACK },
  // Square, round and circle sites get 0px, 6px and 25px; without a theme the controls are pills.
  '--wt-border-radius': { webThemeKey: 'border_radius', fallback: '999px' },
} as const satisfies Record<`--wt-${string}`, { webThemeKey: keyof WebTheme; fallback: string }>;

/** Same order as `TipJar::LAYOUTS`. The first is the default. */
export const TIP_JAR_LAYOUTS = ['banner', 'split', 'centered'] as const satisfies readonly TipJarLayout[];
